import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useSelector } from "react-redux";

//COMPOMENTS
import OrderDetailsOverview from "./orderDetailsOverview";

//STYLES
import * as OrdersStyles from "../../styles/yourOrders/orders";

function YourOrders(props) {
    const [orders, setOrders] = useState([]);

    const user = useSelector((state) => state.user);

    useEffect(() => {
        props.navigation("orders");

        onLoad();
    }, []);

    function onLoad() {
        const data = { userID: user.id };
        Axios.post("/pods/3dPrintingShop/frontEnd/profile/getUsersOrders", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setOrders(data.orders);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={OrdersStyles.body}>
            <br />
            {orders.map((order, index) => {
                return <OrderDetailsOverview key={index} order={order} />;
            })}
        </div>
    );
}

export default YourOrders;
